var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shoplist"},_vm._l((5),function(item){return _c('div',{staticClass:"shopitem"},[_c('img',{attrs:{"src":require("../../../assets/icon6.png"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("10+")]),_vm._v(" "),_c('p',[_vm._v("国企客户")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c3b372","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/components/shoplist.vue
// module id = null
// module chunks = 